"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgRouteAlt(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M18 0a2 2 0 01.402 3.96l-1.905 5.713a2 2 0 01-2.823 2.823L7.96 14.403a2 2 0 11-.633-1.899l5.713-1.905a2.002 2.002 0 011.558-1.558l1.905-5.713A2 2 0 0118 0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('RouteAlt')(SvgRouteAlt);
//# sourceMappingURL=RouteAlt.js.map